import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";
import { EmailDisplay, PhoneDisplay } from "components/display-data";
import Chip from "components/chip";
import { TextDisplay } from "components/display-data";
import Typography from "@material-ui/core/Typography";
import { ROLE_SUPER_USER } from "../../../utils/constants";

const UserData = ({ user, customers, intl, classes, contracts }) => {
  const contractsArray = [];
  const [userContracts, setUserContracts] = useState(null);

  let userCustomers = user?.customerIds;
  const [userCustomersComplete, setUserCustomersComplete] = useState(null);

  const handleContracts = id => {
    const data = contracts.find(contract => contract._id === id);

    userCustomers = userCustomers.filter(customer => customer !== data.customer_id);

    contractsArray.push(data);
    if (user?.serviceContractsFilter.length === contractsArray.length) {
      setUserContracts(contractsArray);
      setUserCustomersComplete(userCustomers);
    }
  };

  useEffect(
    () => {
      if (!!contracts?.length) {
        if (!!user?.serviceContractsFilter?.length) {
          for (const contract of user?.serviceContractsFilter) {
            handleContracts(contract);
          }
        } else {
          const filteredContracts = contracts.filter(contract =>
            user?.customerIds?.find(customer => customer === contract.customer_id),
          );
          setUserContracts(filteredContracts);
        }
      }
    },
    [user?.serviceContractsFilter, contracts],
  );

  useEffect(
    () => {
      if (!!userCustomersComplete?.length && !!contracts?.length) {
        const contractsToAdd = contracts
          .filter(contract => userCustomersComplete.find(userCustomer => contract.customer_id === userCustomer))
          .concat(userContracts);
        setUserContracts(contractsToAdd);
      }
    },
    [userCustomersComplete, contracts],
  );

  return !user ? null : (
    <DataGrid>
      <DataGridItem big>
        <div className={classes.title}>{user?.name}</div>
        <div className={classes.subtitle}>{user?.username}</div>
        <div>
          <EmailDisplay email={user.email} />
        </div>
        <div className={classes.data}>
          <PhoneDisplay phone={user.telephone} />
        </div>
      </DataGridItem>
      <DataGridItem>
        {user?.roles?.map(role => <Chip className={classes.role} key={role.id} label={role.name} />)}
      </DataGridItem>
      <DataGridItem big>
        {user?.roles.find(item => item.name === ROLE_SUPER_USER) ? (
          <DataGridItem big>
            <Typography variant="body1">{intl.formatMessage({ id: "user.access.allCustomers" })}</Typography>
          </DataGridItem>
        ) : (
          <>
            {!!userContracts?.length &&
              user?.customerIds?.map(c => (
                <DataGrid key={c}>
                  <DataGridItem small>
                    <TextDisplay label={intl.formatMessage({ id: "app.customer" })}>
                      {customers?.find(customer => customer._id === c)?.description}
                    </TextDisplay>
                  </DataGridItem>
                  <DataGridItem threeQuarter>
                    <TextDisplay label={intl.formatMessage({ id: "user.contracts" })}>
                      {userContracts
                        .filter(contract => contract.customer_id === c)
                        .map(con => (
                          <Chip className={classes.role} key={con.name} label={con.name} />
                        ))}
                    </TextDisplay>
                  </DataGridItem>
                </DataGrid>
              ))}
          </>
        )}
      </DataGridItem>
    </DataGrid>
  );
};

UserData.propTypes = {
  /**
   * Data to represent
   **/
  user: PropTypes.object,
};

export default withStyles(styles)(injectIntl(UserData));
